import React from "react";
//#region types
import { StyleEnums } from "models/enums";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
import { DocumentDraftTopCardContentProps } from "models/propTypes/documentDraftPropTypes";
//#endregion
//#region components
import { EntityTopCardContent } from "components/common";
import { useDocumentDraftService } from "serviceHooks";
import useDocumentDraftSnoozeAction from "../actions/useDocumentDraftSnoozeAction";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const DocumentDraftTopCardContent: React.FC<DocumentDraftTopCardContentProps> = (props) => {
  const documentDraftService = useDocumentDraftService();
  const { documentDraft, reloadHandler, statusIndicatorDisplayType } = props;

  const snoozeAction = useDocumentDraftSnoozeAction(documentDraft!.id, reloadHandler);

  const title = LocalizationHelperInstance.getFormattedMessage(TranslationKeys.DocumentDraft.ReceivedDocuments);
  const descriptionHeadingTwo =
    documentDraft.subject ?? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.DocumentDraft.NoSubject);
  const descriptionheadingThree = documentDraft.from
    ? `${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.DocumentDraft.SentBy)}: ${documentDraft.from}`
    : LocalizationHelperInstance.getFormattedMessage(TranslationKeys.DocumentDraft.NoSender);

  return documentDraft.state === WintSuperkollAPIModel.DocumentDraftState.Created ? (
    <EntityTopCardContent
      title={title}
      descriptionHeadingTwo={descriptionHeadingTwo}
      descriptionheadingThree={descriptionheadingThree}
      footerText={`${LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.DocumentDraft.Received
      )}: ${LocalizationHelperInstance.getFormattedDate(documentDraft.created)}`}
      quickActions={[snoozeAction]}
      statusIndicatorDisplayType={statusIndicatorDisplayType ?? StyleEnums.DisplayType.Info}
    />
  ) : documentDraft.state === WintSuperkollAPIModel.DocumentDraftState.Handled ? (
    <EntityTopCardContent
      title={title}
      descriptionHeadingTwo={descriptionHeadingTwo}
      descriptionheadingThree={descriptionheadingThree}
      footerText={`${documentDraftService.getStateText(WintSuperkollAPIModel.DocumentDraftState.Handled)}:  ${
        documentDraft.handledDate ? LocalizationHelperInstance.getFormattedDate(documentDraft.handledDate) : ""
      }`}
      statusIndicatorDisplayType={statusIndicatorDisplayType ?? StyleEnums.DisplayType.Success}
    />
  ) : documentDraft.state === WintSuperkollAPIModel.DocumentDraftState.HandledByWint ? (
    <EntityTopCardContent
      title={title}
      descriptionHeadingTwo={descriptionHeadingTwo}
      descriptionheadingThree={descriptionheadingThree}
      footerText={documentDraftService.getStateText(WintSuperkollAPIModel.DocumentDraftState.HandledByWint)}
      statusIndicatorDisplayType={statusIndicatorDisplayType ?? StyleEnums.DisplayType.Info}
    />
  ) : (
    <EntityTopCardContent
      title={title}
      descriptionHeadingTwo={descriptionHeadingTwo}
      descriptionheadingThree={descriptionheadingThree}
      footerText={documentDraftService.getStateText(WintSuperkollAPIModel.DocumentDraftState.Removed)}
      statusIndicatorDisplayType={statusIndicatorDisplayType ?? StyleEnums.DisplayType.None}
    />
  );
};

export default DocumentDraftTopCardContent;
